import { Component } from '@angular/core';

@Component({
    selector   : 'cowtux-demo-sidebar',
    templateUrl: './demo-sidebar.component.html',
    styleUrls  : ['./demo-sidebar.component.scss']
})
export class COWTUXDemoSidebarComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
